import { render } from "./ListCoupons.vue?vue&type=template&id=06845c2c&ts=true"
import script from "./ListCoupons.vue?vue&type=script&lang=ts"
export * from "./ListCoupons.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__